import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Chat from './pages/chat'
import Home from './pages/home'


export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chat" element={<Chat />} />
      </Routes>
    </Router>
  );
}
